import type { ContentBankListItem } from '@/types/apis/ContentBank';
import type { IErrorResponse } from '@/types/apis/Error';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import url from '@/statics/urls';

const useContentBankItem = ({
  id,
}: {
  id: string;
}): UseQueryResult<ContentBankListItem, IErrorResponse> => {
  return useQuery<ContentBankListItem, IErrorResponse>({
    queryKey: [`${url.contentBank}/${id}`],
  });
};
export default useContentBankItem;
